<script>
    export default {
        props: [
            'locale', 
            'initLang',
            'enableCompare',
            'enableCountries',
            'enableBrands',
            'enableSites',
            'enableRange',
            'initMainBrand',
            'initMainSite',
            'initMainCountry',
            'initMainRangeStart',
            'initMainRangeEnd',
            'initCompareBrand',
            'initCompareCountry',
            'initCompareSite',
            'initCompareRangeStart',
            'initCompareRangeEnd',
        ],
        data() {
            return {
                lang: this.initLang,
                mainBrand: this.initMainBrand,
                mainCountry: this.initMainCountry,
                mainSite: this.initMainSite,
                mainRangeStart: this.initMainRangeStart,
                mainRangeEnd: this.initMainRangeEnd,
                compareBrand: this.initCompareBrand,
                compareCountry: this.initCompareCountry,
                compareSite: this.initCompareSite,
                compareRangeStart: this.initCompareRangeStart,
                compareRangeEnd: this.initCompareRangeEnd,
            }
        },
        mounted: function(){
            Event.$emit('dashboardMounted');
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/admin/dashboards/dashboard.vue